import DtoMaterielAssignment from './DtoMaterielAssignment'
import DtoSim from './DtoSim'

export default class DtoStationSimAssignment extends DtoMaterielAssignment {
    constructor(obj) {
        super(obj)
        this.id = obj.idSimSituation
        this.idSimSituation = obj.idSimSituation
        this.idSim = obj.idSim
        this.materielId = obj.idSim
        this.materiel = obj.materiel && new DtoSim(obj.materiel)
    }
}